import React from 'react';
import {STDHeader,HeaderDiv} from './style';
import Logo from './logo';
import HeaderMainIcons from './HeaderMainIcons';

const Header = ({pageSelected, withoutMenu = false}) => {
  
  return (
    <STDHeader>      
      <HeaderDiv id="header_" className="headerDown">
      {!withoutMenu && <HeaderMainIcons pageSelected={pageSelected}/>} 
        <Logo />
      </HeaderDiv>
    </STDHeader>
  );
};

export default Header;
